/**
 * загрузка картинок по скроллу
 */
import {Widget} from "base/assets/js/widget/Widget.js";
export class ImgLazy extends Widget{

	sLoadingClass = 'post__img_loading';

	load() {
		let bSrcSet = this.bl().hasAttribute( 'data-srcset' );
		let bSrc = this.bl().hasAttribute( 'data-src' );
		if( bSrcSet || bSrc ) {
			this._mod( '', this.sLoadingClass, true );
			this._on( '', 'load', () => {
				this._mod( '', this.sLoadingClass, false );
			} )
		}
		if( bSrcSet ) {
			this.bl().setAttribute( 'srcset', this.bl().getAttribute( 'data-srcset' ) );
		}
		if( bSrc ) {
			this.bl().setAttribute( 'src', this.bl().getAttribute( 'data-src' ) );
		}

		if( this.bl().hasAttribute( 'data-bg' ) ) {
			this.bl().style.backgroundImage = 'url( ' + this.bl().getAttribute( 'data-bg' ) + ')';
		}
	}
}